/** @format */
import createMutation from "../create-mutation";

//delete application by id
export const useDeleteApplicationByID = createMutation({
  url: (application_id) => `/application/${application_id}`,
  method: "DELETE",
});

//update application by id
export const useUpdateApplicationByID = createMutation({
  url: (application_id) => `/application/${application_id}`,
  method: "PATCH",
});

//create activity by application id
export const useCreateActivityByApplicationID = createMutation({
  url: (application_id) => `/application/${application_id}/activity`,
  method: "POST",
});

//delete application chat by application id
export const useDeleteChatByApplicationID = createMutation({
  url: (application_id) => `/application/${application_id}/chat`,
  method: "DELETE",
});

//create application chat by application id
export const useCreateChatByApplicationID = createMutation({
  url: (application_id) => `/application/${application_id}/chat`,
  method: "POST",
});

//delete application file by application id
export const useDeleteFileByApplicationID = createMutation({
  url: (application_id) => `/application/${application_id}/file`,
  method: "DELETE",
});

//create application file by application id
export const useCreateFileByApplicationID = createMutation({
  url: (application_id) => `/application/${application_id}/file`,
  method: "POST",
});

//create activity
export const useCreateActivity = createMutation({
  url: "/application/activity",
  method: "POST",
});

//delete activity by id
export const useDeleteActivityByID = createMutation({
  url: (activity_id) => `/application/activity/${activity_id}`,
  method: "DELETE",
});

//update activity by id
export const useUpdateActivityByID = createMutation({
  url: (activity_id) => `/application/activity/${activity_id}`,
  method: "PATCH",
});

//create application by job id
export const useCreateApplicationByJobID = createMutation({
  url: ({ job_id }) => `/application/job/${job_id}`,
  method: "POST",
});
